import { getCurrentLocale } from "@locales/i18n";

export const HELP_CENTER_ROOT_ES = "https://ayuda.tiendanube.com/marketing-nube";
export const HELP_CENTER_ROOT_PT = "https://atendimento.nuvemshop.com.br/nuvem-marketing";

type HelpLocale = "es" | "pt";

const isPtLocale = (locale?: string): boolean =>
  typeof locale === "string" && locale.toLowerCase().startsWith("pt");

const resolveLocale = (locale?: string): HelpLocale => {
  const candidate = locale ?? getCurrentLocale();
  return isPtLocale(candidate) ? "pt" : "es";
};

export const getHelpCenterRootUrl = (locale?: string): string =>
  resolveLocale(locale) === "pt" ? HELP_CENTER_ROOT_PT : HELP_CENTER_ROOT_ES;

interface HelpArticleUrls {
  es: string;
  pt?: string;
}

export const HELP_ARTICLE_URLS: Record<number, HelpArticleUrls> = {
  555: {
    es: "https://ayuda.tiendanube.com/cmo-recibir-reportes-de-resultados-de-campanas-de-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-ler-os-relatorios",
  },
  838: {
    es: "https://ayuda.tiendanube.com/tipos-de-planes",
    pt: "https://atendimento.nuvemshop.com.br/quais-os-tipos-de-planos-do-nuvem-marketing",
  },
  870: {
    es: "https://ayuda.tiendanube.com/como-importar-una-lista-de-contactos-a-marketing-nube-desde-un-archivo-de-excel",
    pt: "https://atendimento.nuvemshop.com.br/como-baixar-relatorios-de-campanha-do-nuvem-marketing-no-excel",
  },
  872: {
    es: "https://ayuda.tiendanube.com/como-duplicar-listas",
    pt: "https://atendimento.nuvemshop.com.br/como-duplicar-listas-de-contato-no-nuvem-marketing",
  },
  873: {
    es: "https://ayuda.tiendanube.com/como-crear-una-nueva-lista-de-audiencia-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-criar-uma-nova-lista-de-audiencia-no-nuvem-marketing",
  },
  875: {
    es: "https://ayuda.tiendanube.com/que-son-los-intereses-de-contacto-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/o-que-sao-os-interesses-de-contatos-no-nuvem-marketing",
  },
  876: {
    es: "https://ayuda.tiendanube.com/crear-campos-personalizados-para-tus-contactos-con-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-criar-campos-personalizados-no-nuvem-marketing",
  },
  877: {
    es: "https://ayuda.tiendanube.com/como-dividir-una-lista-de-contactos",
    pt: "https://atendimento.nuvemshop.com.br/como-dividir-uma-lista-de-contatos-no-nuvem-marketing",
  },
  879: {
    es: "https://ayuda.tiendanube.com/como-tomar-una-muestra-de-una-lista-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-dividir-uma-lista-de-contatos-no-nuvem-marketing",
  },
  951: {
    es: "https://ayuda.tiendanube.com/como-importar-una-lista-de-contactos-a-marketing-nube-desde-un-archivo-de-excel",
    pt: "https://atendimento.nuvemshop.com.br/como-importar-uma-lista-de-contatos-de-um-arquivo-csv",
  },
  959: {
    es: "https://ayuda.tiendanube.com/como-seleccionar-los-destinatarios-de-tus-campanas-de-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-selecionar-os-destinatarios-nas-campanhas-do-nuvem-marketing",
  },
  963: {
    es: "https://ayuda.tiendanube.com/como-personalizar-tus-campanas-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-personalizar-uma-campanha-no-nuvem-marketing",
  },
  1032: {
    es: "https://ayuda.tiendanube.com/como-unir-dos-o-mas-listas-de-contactos-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-unificar-duas-ou-mais-listas-de-contatos-no-nuvem-marketing",
  },
  1036: {
    es: "https://ayuda.tiendanube.com/como-sustraer-contactos-entre-listas-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-subtrair-contatos-entre-listas-no-nuvem-marketing",
  },
  1040: {
    es: "https://ayuda.tiendanube.com/como-importar-una-lista-de-contactos-en-maketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-importar-uma-lista-de-contatos-no-nuvem-marketing",
  },
  1046: {
    es: "https://ayuda.tiendanube.com/como-personalizar-el-asunto-de-una-campana-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-personalizar-o-assunto-de-uma-campanha",
  },
  1047: {
    es: "https://ayuda.tiendanube.com/como-hacer-envios-de-prueba-con-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/envio-de-teste",
  },
  1079: {
    es: "https://ayuda.tiendanube.com/como-armar-tu-primera-campana-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-criar-sua-primeira-campanha-no-nuvem-marketing",
  },
  1613: {
    es: "https://ayuda.tiendanube.com/organizacion-de-contactos-y-listas",
    pt: "https://atendimento.nuvemshop.com.br/como-organizar-seus-contatos-e-listas-no-nuvem-marketing",
  },
  1614: {
    es: "https://ayuda.tiendanube.com/como-limpiar-tus-listas-de-contactos-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-limpar-as-listas-de-contatos-do-nuvem-marketing",
  },
  1615: {
    es: "https://ayuda.tiendanube.com/como-desuscribir-un-contacto-de-tu-lista-de-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-descadastrar-um-contato-do-nuvem-marketing",
  },
  1616: {
    es: "https://ayuda.tiendanube.com/como-entender-la-calificacion-y-el-estado-de-mis-contactos-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/classificacao-e-status-do-contato",
  },
  1619: {
    es: "https://ayuda.tiendanube.com/cuales-son-los-estados-de-una-campana-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/quais-sao-os-status-das-campanhas-no-nuvem-marketing",
  },
  1680: {
    es: "https://ayuda.tiendanube.com/como-asignar-intereses-a-los-contactos-en-una-importacion-de-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/atribuir-interesses-a-contatos-de-uma-importacao",
  },
  1682: {
    es: "https://ayuda.tiendanube.com/como-incluir-intereses-en-los-formularios-de-markeing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-incluir-interesses-nos-formularios-do-nuvem-marketing",
  },
  1748: {
    es: "https://ayuda.tiendanube.com/para-que-sirve-y-como-puedo-crear-un-formulario",
    pt: "https://atendimento.nuvemshop.com.br/para-que-serve-e-como-posso-criar-um-formulario",
  },
  1749: {
    es: "https://ayuda.tiendanube.com/como-enviar-una-campana-segmentada-por-interes-",
    pt: "https://atendimento.nuvemshop.com.br/como-enviar-uma-campanha-segmentada-por-interesse",
  },
  1822: {
    es: "https://ayuda.tiendanube.com/crear-emails-que-se-adapten-automaticamente-a-cada-cliente-con-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-criar-e-mails-que-se-adaptam-automaticamente-a-cada-cliente-com-nuvem-marketing",
  },
  1823: {
    es: "https://ayuda.tiendanube.com/como-editar-los-datos-de-un-contacto",
    pt: "https://atendimento.nuvemshop.com.br/como-importar-contatos-manualmente",
  },
  1827: {
    es: "https://ayuda.tiendanube.com/como-definir-destinatarios-con-base-en-su-actividad-en-campanas-previas",
    pt: "https://atendimento.nuvemshop.com.br/como-definir-destinatarios-com-base-em-sua-atividade-em-campanhas-anteriores-no-nuvem-marketing",
  },
  3965: {
    es: "https://ayuda.tiendanube.com/que-hacer-con-los-contactos-duplicados-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/o-que-fazer-com-contatos-duplicados",
  },
  596581: {
    es: "https://ayuda.tiendanube.com/como-crear-usuarios-y-definir-sus-roles-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-criar-usuarios-e-definir-suas-funcoes",
  },
  610332: {
    es: "https://ayuda.tiendanube.com/como-configurar-la-direccion-postal-de-mi-empresa-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/endereco-postal",
  },
  790876: {
    es: "https://ayuda.tiendanube.com/como-integrar-google-analytics-con-tus-campanas-de-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/google-analytics-nuvem-marketing",
  },
  830381: {
    es: "https://ayuda.tiendanube.com/como-crear-multicuentas-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/multiconta-gerenciamento-de-subcontas",
  },
  868988: {
    es: "https://ayuda.tiendanube.com/como-compartir-los-reportes-de-una-campana-de-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-compartilhar-os-relatorios-de-uma-campanha-do-nuvem-marketing",
  },
  1146685: {
    es: "https://ayuda.tiendanube.com/autenticar-remitente-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-posso-autenticar-corretamente-meu-dominio-para-usa-lo-como-remetente-em-meus-envios",
  },
  1157486: {
    es: "https://ayuda.tiendanube.com/como-crear-nuevas-listas-con-base-en-filtros",
    pt: "https://atendimento.nuvemshop.com.br/como-criar-novas-listas-com-base-em-filtros",
  },
  1427859: {
    es: "https://ayuda.tiendanube.com/como-encontrar-los-contactos-presentes-en-varias-listas",
    pt: "https://atendimento.nuvemshop.com.br/como-encontrar-os-contatos-presentes-em-varias-listas",
  },
  1437451: {
    es: "https://ayuda.tiendanube.com/como-obtener-mi-api-key-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-obter-minha-chave-api",
  },
  1820858: {
    es: "https://ayuda.tiendanube.com/como-registrar-y-gestionar-remitentes-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-registrar-e-gerenciar-os-remetentes-no-nuvem-marketing",
  },
  2589810: {
    es: "https://ayuda.tiendanube.com/integracion-con-vtex",
    pt: "https://atendimento.nuvemshop.com.br/automations-para-vtex",
  },
  2637585: {
    es: "https://ayuda.tiendanube.com/como-crear-segmentos-automaticos-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-criar-segmentos-automaticos-no-nuvem-marketing",
  },
  2845428: {
    es: "https://ayuda.tiendanube.com/como-funciona-el-plan-por-contactos-de-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-funciona-o-plano-por-contatos-do-nuvem-marketing",
  },
  3148714: {
    es: "https://ayuda.tiendanube.com/integracion-con-cliengo",
  },
  3275033: {
    es: "https://ayuda.tiendanube.com/como-crear-cuentas-de-email-con-mi-dominio-propio",
    pt: "https://atendimento.nuvemshop.com.br/como-obter-um-e-mail-com-o-seu-proprio-dominio",
  },
  3296158: {
    es: "https://ayuda.tiendanube.com/como-crear-una-campana-con-un-reenvio-programado-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-criar-uma-campanha-com-um-reenvio-programado-no-nuvem-marketing",
  },
  3351234: {
    es: "https://ayuda.tiendanube.com/que-tipos-de-automations-puedo-activar-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/quais-tipos-de-automacoes-posso-ativar-no-nuvem-marketing",
  },
  3459857: {
    es: "https://ayuda.tiendanube.com/configuracion-de-triggers-en-vtex",
  },
  4283881: {
    es: "https://ayuda.tiendanube.com/como-configurar-un-automation-de-cumpleanos-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-configurar-um-automation-de-aniversario",
  },
  4302126: {
    es: "https://ayuda.tiendanube.com/cmo-recibir-reportes-de-resultados-de-campanas-de-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/relatorios-periodicos-por-e-mail",
  },
  4360664: {
    es: "https://ayuda.tiendanube.com/integracion-con-jivochat",
  },
  5090969: {
    es: "https://ayuda.tiendanube.com/como-crear-una-campana-ab-testing",
    pt: "https://atendimento.nuvemshop.com.br/como-criar-uma-campanha-de-teste-a-b",
  },
  5228167: {
    es: "https://ayuda.tiendanube.com/como-crear-campanas-inteligentes-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/campanhas-inteligentes",
  },
  5386059: {
    es: "https://ayuda.tiendanube.com/como-configurar-datos-adicionales-de-remitentes-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/dados-adicionais-do-remetente",
  },
  5628941: {
    es: "https://ayuda.tiendanube.com/integracion-con-jumpseller",
  },
  5665758: {
    es: "https://ayuda.tiendanube.com/automations-para-shopify",
    pt: "https://atendimento.nuvemshop.com.br/automations-para-shopify",
  },
  5666234: {
    es: "https://ayuda.tiendanube.com/automations-para-vtex",
    pt: "https://atendimento.nuvemshop.com.br/automations-para-vtex",
  },
  5666279: {
    es: "https://ayuda.tiendanube.com/automations-para-woocommerce",
    pt: "https://atendimento.nuvemshop.com.br/automations-para-woocommerce",
  },
  6235468: {
    es: "https://ayuda.tiendanube.com/integracion-con-crossup",
  },
  6236706: {
    es: "https://ayuda.tiendanube.com/como-eliminar-listas-de-contactos-de-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-excluir-listas-de-contatos-do-nuvem-marketing",
  },
  6671345: {
    es: "https://ayuda.tiendanube.com/introduccion-a-automations",
    pt: "https://atendimento.nuvemshop.com.br/o-que-sao-os-e-mails-automaticos-do-nuvem-marketing",
  },
  6720373: {
    es: "https://ayuda.tiendanube.com/integracion-con-integrately",
  },
  6720480: {
    es: "https://ayuda.tiendanube.com/editando-plantillas-cuerpo",
    pt: "https://atendimento.nuvemshop.com.br/editando-templates-corpo",
  },
  6827777: {
    es: "https://ayuda.tiendanube.com/editando-plantillas-cuerpo",
    pt: "https://atendimento.nuvemshop.com.br/editando-templates-corpo",
  },
  6840772: {
    es: "https://ayuda.tiendanube.com/que-es-una-campana-y-que-tipos-de-envio-hay-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/quais-sao-os-tipos-de-campanha-do-nuvem-marketing",
  },
  6967392: {
    es: "https://ayuda.tiendanube.com/configurando-formularios-sin-codigo",
    pt: "https://atendimento.nuvemshop.com.br/implementando-formularios-sem-codigo",
  },
  6967467: {
    es: "https://ayuda.tiendanube.com/configurando-formularios-sin-codigo",
    pt: "https://atendimento.nuvemshop.com.br/configurando-formularios-sem-codigo",
  },
  6979913: {
    es: "https://ayuda.tiendanube.com/editando-plantillas-ajustes-de-fuentes",
    pt: "https://atendimento.nuvemshop.com.br/editando-plantillas-ajustes-de-fontes",
  },
  6980992: {
    es: "https://ayuda.tiendanube.com/editando-plantillas-cuerpo",
    pt: "https://atendimento.nuvemshop.com.br/editando-templates-corpo",
  },
  7054063: {
    es: "https://ayuda.tiendanube.com/como-funciona-el-ciclo-de-vida-de-los-compradores-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-funciona-o-ciclo-de-vida-dos-compradores-no-nuvem-marketing",
  },
  7150769: {
    es: "https://ayuda.tiendanube.com/como-crear-una-plantilla-de-email-en-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/como-criar-uma-campanha-com-um-reenvio-programado-no-nuvem-marketing",
  },
  8075853: {
    es: "https://ayuda.tiendanube.com/como-desactivar-los-emails-automaticos",
    pt: "https://atendimento.nuvemshop.com.br/como-desativar-os-e-mails-automaticos-da-nuvemshop",
  },
  8219182: {
    es: "https://ayuda.tiendanube.com/integracion-con-storydots",
    pt: "https://atendimento.nuvemshop.com.br/integracao-com-storydots",
  },
  8593204: {
    es: "https://ayuda.tiendanube.com/que-es-la-audiencia-de-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/o-que-e-a-audiencia-do-nuvem-marketing",
  },
  9589024: {
    es: "https://ayuda.tiendanube.com/como-automatizar-el-envio-de-gift-cards-para-tus-clientes-desde-marketing-nube",
    pt: "https://atendimento.nuvemshop.com.br/automacao-de-compra-de-gift-card",
  },
  10521706: {
    es: "https://ayuda.tiendanube.com/elementos-de-tu-marca",
    pt: "https://atendimento.nuvemshop.com.br/como-configurar-os-elementos-da-sua-marca-no-nuvem-marketing",
  },
};

export const HELP_COLLECTION_URLS: Record<string, HelpArticleUrls> = {
  "147051": {
    es: "https://ayuda.tiendanube.com/es_ES/puesta-en-marcha",
    pt: "https://atendimento.nuvemshop.com.br/pt_BR/nuvem-marketing-primeiros-passos",
  },
  "147059": {
    es: "https://ayuda.tiendanube.com/es_ES/listas",
    pt: "https://atendimento.nuvemshop.com.br/pt_BR/minha-audiencia",
  },
  "3305748": {
    es: "https://ayuda.tiendanube.com/es_ES/campanas-de-email",
    pt: "https://atendimento.nuvemshop.com.br/pt_BR/campanhas-de-email",
  },
};

const toNumericId = (id: number | string): number | undefined => {
  const parsed = typeof id === "number" ? id : Number.parseInt(id, 10);
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const getHelpArticleUrl = (id: number | string, locale?: string): string => {
  const numericId = toNumericId(id);
  const resolvedLocale = resolveLocale(locale);
  if (numericId === undefined) {
    return getHelpCenterRootUrl(resolvedLocale);
  }
  const entry = HELP_ARTICLE_URLS[numericId];
  if (!entry) {
    return getHelpCenterRootUrl(resolvedLocale);
  }
  if (resolvedLocale === "pt" && entry.pt) {
    return entry.pt;
  }
  return entry.es;
};

export const openHelpArticle = (id: number | string): void => {
  const url = getHelpArticleUrl(id);
  if (typeof window !== "undefined") {
    window.open(url, "_blank", "noopener,noreferrer");
  }
};

export const getHelpCollectionUrl = (id: number | string, locale?: string): string => {
  const resolvedLocale = resolveLocale(locale);
  const entry = HELP_COLLECTION_URLS[String(id)];
  if (!entry) {
    return getHelpCenterRootUrl(resolvedLocale);
  }
  if (resolvedLocale === "pt" && entry.pt) {
    return entry.pt;
  }
  return entry.es;
};
